export default [
    // require('@/assets/images/tab-panel.png'),
    // require('@/assets/images/skin-1.png'),
    // require('@/assets/images/skin-2.png'),
    // require('@/assets/images/skin-3.png'),
    // require('@/assets/images/skin-4.png'),
    // require('@/assets/images/skin-5.png'),
    // require('@/assets/images/skin/skin-1.png'),
    // require('@/assets/images/skin/skin-2.png'),
    // require('@/assets/images/skin/skin-3.png'),
    // require('@/assets/images/skin/skin-4.png'),
    // require('@/assets/images/skin/skin-5.png'),
];


// WEBPACK FOOTER //
// ./src/assets/js/imgPreloaderList.js